export class UserFilter {
  name: string;
  socialSecurityNumber: string;
  partner: number;
  status: string = 'ALL';
}
